import { useContextSelectors } from "@-/com.npmjs.use-context-selectors";
import runes from "@-/com.npmjs.runes2";
import { hasMinLength } from "@-/com.npmjs.ts-array-length";
import {
  GraphemeInfoFlashcardSurface,
  WordInfoFlashcardSurface,
} from "@-/dev.improve.haniverse.routes.nav.app._components.morpheme.panels";
import { LearnFlashcardSurfaceReadyMarker } from "@-/dev.improve.haniverse.routes.nav.app.learn.deck.context";
import { DrillPageContext } from "@-/dev.improve.haniverse.routes.nav.app.learn.drill._context";

/**
 * The Info surface for the item being drilled: the reference panel for a grapheme, the word info
 * view for a word. Prepared independently of the study faces — its sections load inside their own
 * boundaries, so a slow reference section can never hold up reviewing.
 */
export function DrillFlashcardInfo() {
  const [character] = useContextSelectors(DrillPageContext, (c) => c.character);
  const isWord = hasMinLength(runes(character), 2);
  return isWord ? (
    <WordInfoFlashcardSurface word={character}>
      <LearnFlashcardSurfaceReadyMarker />
    </WordInfoFlashcardSurface>
  ) : (
    <GraphemeInfoFlashcardSurface grapheme={character}>
      <LearnFlashcardSurfaceReadyMarker />
    </GraphemeInfoFlashcardSurface>
  );
}
